import { Message } from "element-ui";
export function getAgeByCardId(idNumber) {
    /*身份证号码校验是否符合规则*/
    /*去掉首尾空格*/
    idNumber = idNumber.replace(/(^\s*)|(\s*$)/g, '')
    if (!idNumber.match(/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/)) {
        Message.error('身份证号格式错误')
        return false
    }

    const birthYear = idNumber.substr(6, 4)
    const birthMonth = idNumber.substr(10, 2)
    const birthDay = idNumber.substr(12, 2)
    const d = new Date();
    const nowYear = d.getFullYear();
    const nowMonth = d.getMonth() + 1;
    const nowDay = d.getDate(); // 成年当天/65周岁当天 不可以签字 所以日期加1，减1
    let returnAge = 0
    if (nowYear == birthYear && nowMonth <= birthMonth && nowDay <= birthDay) {
        returnAge = 0;//同年 则为0岁
    } else {
        const ageDiff = nowYear - birthYear; //年之差
        if (ageDiff > 0) {
            if (nowMonth == birthMonth) {
                const dayDiff = nowDay - birthDay;//日之差
                if (dayDiff < 0) {
                    returnAge = ageDiff - 1;
                } else {
                    returnAge = ageDiff;
                }
            } else {
                const monthDiff = nowMonth - birthMonth;//月之差
                if (monthDiff < 0) {
                    returnAge = ageDiff - 1;
                } else {
                    returnAge = ageDiff;
                }
            }
        } else {
            returnAge = -1;//返回-1 表示出生日期输入错误 晚于今天
        }
    }
    // Calculate actual 18th and 65th birthdays
    const eighteenthBirthday = new Date(parseInt(birthYear) + 18, parseInt(birthMonth) - 1, parseInt(birthDay));
    const sixtiethBirthday = new Date(parseInt(birthYear) + 65, parseInt(birthMonth) - 1, parseInt(birthDay));
    const today = new Date();
    
    // Check if under 18 (before 18th birthday)
    if (today < eighteenthBirthday) {
        Message.error('年龄必须是18-65之间')
        return false
    } 
    // Check if over 65 (on or after 65th birthday)
    else if (today >= sixtiethBirthday) {
        Message.error('年龄必须是18-65之间')
        return false
    } 
    else {
        return true
    }
}

